<template>
  <div class="foot"  v-cloak>
    <div class="top">
      <div class="first">
        <img src="../assets/img/logo3.png" alt srcset />
        <p>电话：{{ detail.tel }}</p>
        <p>传真：{{ detail.cz }}</p>
        <p>邮箱：{{ detail.yx }}</p>
        <p>
          地址：
          <span>{{ detail.address }}</span>
        </p>
      </div>
      <div class="ul">
        <p class="title">民用产品</p>
        <router-link
          tag="p"
          :to="{ path: '/product', query: { idx: item.id } }"
          v-for="(item, index) in classe"
          :key="index"
          >{{ item.name }}</router-link
        >
      </div>
      <div class="ul">
        <p class="title">新闻中心</p>
        <router-link tag="p" :to="{ path: '/news/company' }"
          >企业新闻</router-link
        >
        <router-link tag="p" :to="{ path: '/news/industry' }"
          >技术动态</router-link
        >
      </div>
      <div class="ul">
        <p class="title">关于我们</p>
        <router-link tag="p" :to="{ path: '/joinUs' }">加入我们</router-link>
        <router-link tag="p" :to="{ path: '/concact' }">联系我们</router-link>
      </div>
      <div class="ul">
        <p class="title">官方公众号</p>
        <img :src="detail.image" alt srcset />
      </div>
    </div>

    <div class="down">
      <p @click="to">ALL RIGHTS RESERVED 2019 © JC ELECTRON.COM 蜀ICP10202701号-1</p>
    </div>
    <div class="affix" @click="show = true">
      <!-- <i class="el-icon-service"></i> -->
      <img src="../assets/img/call.png" alt srcset />
      <span>产品咨询</span>
    </div>
    <el-dialog :visible.sync="show" width="800px" custom-class="custom">
      <p class="dialog-title">产品咨询</p>
      <div class="wrapper">
        <div>
          <img src="../assets/img/qq.png" alt srcset />
          <p class="title">网络联系方式</p>
          <p class="desc">
            <a
              target="_blank"
              :href="`http://wpa.qq.com/msgrd?v=3&uin=${3213910671}&site=qq&menu=yes`"
              >{{ 3213910671 }}</a
            >
            <br />
            <a
              target="_blank"
              :href="`http://wpa.qq.com/msgrd?v=3&uin=${837072040}&site=qq&menu=yes`"
              >{{ 837072040 }}</a
            >
          </p>
        </div>
        <div>
          <img src="../assets/img/email.png" alt srcset />
          <p class="title">邮箱联系方式</p>
          <p class="desc">
            {{ detail.yx }}
          </p>
        </div>
        <div>
          <img src="../assets/img/tel.png" alt srcset />
          <p class="title">通信联系方式</p>
          <p class="desc">{{ detail.tel }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pz, classe } from '../assets/js/api'
export default {
  data() {
    return {
      detail: {},
      classe: [],
      show: false,
    }
  },
  created() {
    pz().then((r) => {
      this.detail = r.data
    })
    classe({
      limit: 7,
    }).then((r) => {
      this.classe = r.data.data
    })
  },
  methods: {
    to() {
      window.open('https://beian.miit.gov.cn/')
    },
  },
}
</script>

<style lang="less" scoped>
.affix {
  width: 70px;
  height: 70px;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #f8bc0c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 40px;
  border-radius: 10px 0px 0px 10px;
  cursor: pointer;
  z-index: 10;
  flex-direction: column;

  img {
    width: 25px;
    margin-bottom: 5px;
  }

  span {
    font-size: 12px;
   
  }
}

.dialog-title {
  width: 40px;
  padding: 10px 0;
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(75, 75, 75, 1);
  border-bottom: 2px solid rgba(0, 160, 233, 1);
  white-space: nowrap;
  text-align: center;
  margin: 0 auto;
  text-indent: -1.5em;
  margin-bottom: 50px;
}

/deep/ .custom {
  transform: translate(50%, 150px);
}

.wrapper {
  display: flex;
  padding-bottom: 70px;

  div {
    width: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    padding-top: 15px;

    .title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }

    .desc {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-top: 20px;
      padding: 0 20px;
      box-sizing: border-box;
      white-space: pre-wrap;
    }

    img {
      height: 60px;
      margin-bottom: 48px;
    }
  }

  div:nth-child(2) {
    border-left: 1px solid #c1c1c1;
    border-right: 1px solid #c1c1c1;
  }
}

.foot {
  padding-top: 50px;
  background: rgba(4, 42, 68, 0.9);
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(146, 146, 146, 1);

  & > p {
    text-align: center;
    margin-top: 50px;
  }

  & > .top {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 70px;
    display: flex;
    justify-content: space-between;

    .first {
      width: 366px;

      p {
        display: flex;
        margin-bottom: 17px;
        // white-space: pre;
      }
      p:last-child {
        white-space: pre-line;
      }
      span {
        display: inline-block;
        width: calc(100% - 3em);
      }

      img {
        width: 108px;
        height: 38px;
        margin-bottom: 8px;
      }
    }

    .ul {
      .title {
        font-weight: bold;
        color: rgba(184, 184, 184, 1);
        margin-bottom: 30px;
      }

      p:not(:first-child) {
        margin-bottom: 17px;
        cursor: pointer;
      }

      img {
        width: 98px;
        height: 98px;
        object-fit: cover;
        box-shadow: 1px 1px 15px 7px #000000;
      }
    }
  }

  .down {
    width: 100%;
    height: 78px;
    background: #0c1e2a;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      cursor: pointer;
    }
  }
}
</style>
